// Copyright (c) 2016 Deere & Company

import SecurityModuleFeature from './security-module-feature';
import t from 'tcomb';

const SecurityModule = t.struct({
    features: t.list(SecurityModuleFeature, 'SecurityModuleFeature'),
    isAllowed: t.Bool,
    module: t.String
}, {
    name: 'SecurityModule',
    strict: true
});

export const getDefaultState = () => new SecurityModule({
    features: [],
    isAllowed: false,
    module: ''
});

export default SecurityModule;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/security-module.js